import React from "react";

function DashHomePage() {
  return <div>DashHomePage</div>;
}

export default DashHomePage;
